import * as z from 'zod';
import { ErrorMessages } from './error-messages';

export const resetPasswordFormSchema = z.object({
  password: z
    .string()
    .min(8, ErrorMessages.Password.TOO_SHORT)
    .regex(/[^a-zA-Z]/, ErrorMessages.Password.MISSING_NUMBER_OR_SYMBOL),
});

export type ResetPasswordFormData = z.TypeOf<typeof resetPasswordFormSchema>;
